"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterContractTypesStats = exports.filterOutExternalContractStats = exports.filterOutDefaultContractStats = exports.filterOutNoContractStats = exports.filterOutCoreContractsStats = exports.filterContractTypes = exports.filterOutExternalContract = exports.filterOutDefaultContract = exports.filterOutNoContract = exports.filterOutCoreContracts = void 0;
const filterOutCoreContracts = (contractType) => !contractType.id.includes('core');
exports.filterOutCoreContracts = filterOutCoreContracts;
const filterOutNoContract = (contractType) => !contractType.id.includes('no-contract');
exports.filterOutNoContract = filterOutNoContract;
const filterOutDefaultContract = (contractType) => !contractType.id.includes('default');
exports.filterOutDefaultContract = filterOutDefaultContract;
// for sportisimo logistika
const filterOutExternalContract = (enableExternalContractTypeOption) => (contractType) => enableExternalContractTypeOption ? true : !contractType.id.includes('external');
exports.filterOutExternalContract = filterOutExternalContract;
const filterContractTypes = (enableExternalContractTypeOption) => (contractTypes) => contractTypes
    .filter(exports.filterOutCoreContracts)
    .filter(exports.filterOutNoContract)
    .filter(exports.filterOutDefaultContract)
    .filter((0, exports.filterOutExternalContract)(enableExternalContractTypeOption));
exports.filterContractTypes = filterContractTypes;
const filterOutCoreContractsStats = (contractType) => !contractType.contractType?.includes('core');
exports.filterOutCoreContractsStats = filterOutCoreContractsStats;
const filterOutNoContractStats = (contractType) => !contractType.contractType?.includes('no-contract');
exports.filterOutNoContractStats = filterOutNoContractStats;
const filterOutDefaultContractStats = (contractType) => !contractType.contractType?.includes('default');
exports.filterOutDefaultContractStats = filterOutDefaultContractStats;
// for sportisimo logistika
const filterOutExternalContractStats = (enableExternalContractTypeOption) => (contractType) => enableExternalContractTypeOption
    ? true
    : !contractType.contractType?.includes('external');
exports.filterOutExternalContractStats = filterOutExternalContractStats;
const filterContractTypesStats = (enableExternalContractTypeOption) => (contractTypes) => contractTypes
    .filter(exports.filterOutCoreContractsStats)
    .filter(exports.filterOutNoContractStats)
    .filter(exports.filterOutDefaultContractStats)
    .filter((0, exports.filterOutExternalContractStats)(enableExternalContractTypeOption));
exports.filterContractTypesStats = filterContractTypesStats;
